module.exports = __webpack_public_path__ + "img/share-icon-audio.3e093465.svg";